import { render, staticRenderFns } from "./manage-look-up-data-modal.vue?vue&type=template&id=14736d64"
import script from "./manage-look-up-data-modal.vue?vue&type=script&lang=js"
export * from "./manage-look-up-data-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports